module.exports = __webpack_public_path__ + "bf9547ac.jpg";